import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-ink text-white" data-id="element-0" data-mp="31brz38d2snk2">
      <MetaPixel data-id="element-1" data-mp="2wjgq7g0cxrfd" />
      <main data-id="element-2" data-mp="2wiyvwox99na3">
        <Hero data-id="element-3" data-mp="2wiffjcn976y6" />
        <Stats data-id="element-4" data-mp="2wip2ssgwz006" />
        <Testimonials data-id="element-5" data-mp="2wi5m1f302hnq" />
        <PainPoints data-id="element-6" data-mp="28tw5osok2m3z" />
        <Tomos data-id="element-7" data-mp="28te2fc3h77mk" />
        <Bonuses data-id="element-8" data-mp="28sutgkvsztko" />
        <Countdown data-id="element-9" data-mp="28sbbx5a2f776" />
        <Pricing data-id="element-10" data-mp="23vchsmqej08z" />
        <FAQ data-id="element-11" data-mp="23vuq4hqc94x9" />
        <Countdown data-id="element-12" data-mp="23u9tmmkgrbwr" />
        <ValueStack data-id="element-13" data-mp="23utby4e102bb" />
      </main>
      <Footer data-id="element-14" data-mp="23ti5txx3yih1" />
    </div>;
}